import React from "react";
import PropTypes from "prop-types";
import BondAttorneyInformationBase from "../../../../../features/bonds/shared/components/sections/BondAttorneyInformationBase";
import { gVal } from "../../historicGuardianUtils";

/** Thin wrapper — historic guardian attorney section (Phase 9.10B). */
export default function HistoricAttorneySection(props) {
  return <BondAttorneyInformationBase {...props} gVal={gVal} />;
}

HistoricAttorneySection.propTypes = {
  index: PropTypes.number.isRequired,
  guardian: PropTypes.object.isRequired,
  guardians: PropTypes.array.isRequired,
  cfg: PropTypes.object.isRequired,
  keys: PropTypes.object.isRequired,
  attorneys: PropTypes.array.isRequired,
  loadingAttorneys: PropTypes.bool.isRequired,
  errors: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  updateData: PropTypes.func.isRequired,
  GoogleAutoComplete: PropTypes.elementType.isRequired,
  LabeledCreatableSelect: PropTypes.elementType.isRequired,
  allCities: PropTypes.array.isRequired,
  allStates: PropTypes.array.isRequired,
  loadingCitiesStates: PropTypes.bool.isRequired,
  handleAttorneyHomeAddressChange: PropTypes.func.isRequired,
  handleAttorneySelection: PropTypes.func.isRequired,
  handleGoogleCallback: PropTypes.func.isRequired,
  handleZipCodeChange: PropTypes.func.isRequired,
};
